import React, {useState, useEffect, createRef} from 'react';
import {connect} from 'react-redux';
import './Graph.css';
import TopBarMenu from '../../General/TopbarMenu/TopBarMenu';
import MapButtons from '../../../Utils/Forms/MapButtons';
import CombinedFilter from '../../General/Filter/CombinedFilter/CombinedFilter';
import { ChangeFilterCondition } from '../ManageList/Functions/FilterState';
import AddListsIntoFilters from '../../../Utils/Forms/AddListsIntoFilters';
import GraphFactory from './GraphFactory';
import FormatDataIntoGraph from './GraphUtils';
import Post from '../../../Data/Post';
import TranslateTag from '../../../Utils/Local/TranslateTag';

const Graph = (props) => {

    const [currentGraph, setCurrentGraph] = useState({});
    const [sourceData, setSourceData] = useState();
    const [filterState, setFilterState] = useState({});
    const [threedimensions, setThreeDimensions] = useState();
    const [twodimensions, setTwoDimensions] = useState();

    const graphElement = createRef(null);

    const backgroundColors = [
        'rgba(255, 99, 132, 0.6)',
        'rgba(54, 162, 235, 0.6)',
        'rgba(255, 206, 86, 0.6)',
        'rgba(75, 192, 192, 0.6)',
        'rgba(153, 102, 255, 0.6)',
        'rgba(255, 159, 64, 0.6)',
        'rgba(255, 99, 132, 0.6)',
        'rgba(245, 39, 245, 0.8)',
        'rgba(52, 39, 245, 0.8)',
        'rgba(245, 245, 39, 0.8)',
        'rgba(245, 39, 61, 0.8)',
        'rgba(43, 245, 39, 0.8)',
        'rgba(155, 99, 32, 0.6)',
        'rgba(54, 62, 135, 0.6)',
        'rgba(155, 106, 86, 0.6)',
        'rgba(75, 92, 92, 0.6)',
        'rgba(53, 2, 155, 0.6)',
        'rgba(155, 59, 64, 0.6)',
        'rgba(155, 99, 32, 0.6)',
        'rgba(145, 39, 145, 0.8)',
        'rgba(52, 39, 145, 0.8)',
        'rgba(145, 145, 39, 0.8)',
        'rgba(145, 39, 61, 0.8)',
        'rgba(43, 145, 39, 0.8)'
    ]

    useEffect(() => {
        setCurrentGraph(props.graphs[0]);
        const filters = AddListsIntoFilters(props.graphs[0].Filters, props.lists);
        setDefaultFilters(filters);
        setFilterState({filters: filters});
    }, [props.config]);

    const setDefaultFilters = (filters) => {
        for (const filter of filters) {
            if (filter.Key === "graphtype") { filter.values =  ['478']; }
            if (filter.Key === "dateinterval") { filter.values =  ['480']; }
        }
    }

    const GenerateData = (currentFilterState) => {

        currentFilterState = currentFilterState === undefined ? filterState : currentFilterState;
        const param = [];
        for (const filter of currentFilterState.filters) { 
            if (filter.values !== undefined) {
                const newQueryFilter = { Key: filter.FieldName, Value: filter.values.join()}
                param.push(newQueryFilter);               
            }
        }

        if (currentFilterState.startDate !== undefined) {
            const newQueryFilter = { Key: "StartDate", Value: currentFilterState.startDate}
            param.push(newQueryFilter);     
        }

        if (currentFilterState.endDate !== undefined) {
            const newQueryFilter = { Key: "EndDate", Value: currentFilterState.endDate}
            param.push(newQueryFilter);     
        }

        if (param.length > 0) {
            const criteria = { Name: currentGraph.Name, Parameters: param};
            Post('graph/getdata', criteria, dataRetrievedSuccessfully, errorWhenRetrievingData);
        }
    }

    const sectionContentsSort = (a, b) => {
        if (a.Value < b.Value) {
          return -1;
        }
        if (a.Value > b.Value) {
          return 1;
        }
        return 0;
      }

    const AddNewSection = (sections, newData, labelCount) => {

        newData.sort(sectionContentsSort);
        // Put in the data for existing sections
        for (const section of sections) {
             const newDataLine = newData.filter(d => d.Value === section.Value);
             if (newDataLine.length === 0) {
                section.Data.push(0);
             } else {
                section.Data.push(newDataLine[0].Number)
             }
        }

        //Put in any new sections which do not exist
        for (const newDataLine of newData) {
            const foundSection = sections.filter(d => d.Value === newDataLine.Value);
            if (foundSection.length === 0) {
                var data = [];
                for (var i = 1; i < labelCount; i++) {
                    data.push(0);
                }
                data.push(newDataLine.Number);

                const newSection = {Key: sections.length + 1, Value: newDataLine.Value, Data: data};
                sections.push(newSection);
            }
        }

        return sections;
    }

    const CreateTwoDimensionsFromThreeDimensions = (three) => {
        const labels = [];
        const sections =  [{
            Value: "",
            Data: []
        }];
        for (const section of three.Sections) {
            labels.push({Key: section.Key, Value: section.Value});
            const total = section.Data.reduce((p, a) => p + a, 0);
            sections[0].Data.push(total);
        }
        const twoDim = {Labels: labels, Sections: sections}
        setTwoDimensions(twoDim);
    }

    const ReorganiseData = (data) => {

        const returnedData = [];
        let filterResults = [];
        const intervalFilter = filterState.filters.filter(f => f.Key === "dateinterval")[0].values[0];

        for (const item of data) {
            if (intervalFilter === "479") {
                filterResults = returnedData.filter(d => d.Value === item.Value && d.Day === item.Day);
            }
            if (intervalFilter === "480") {
                filterResults = returnedData.filter(d => d.Value === item.Value && d.Month === item.Month);
            }
            if (intervalFilter === "481") {
                filterResults = returnedData.filter(d => d.Value === item.Value && d.Year === item.Year);
            }

            if (filterResults.length === 0) {
                returnedData.push(item);
            } else {
                filterResults[0].Number += item.Number;
            }
        }
        return returnedData;
    }

    const GenerateThreeDimensions = (data) => {
        let currentLabel = "";
        let labelKeyCount = 0;
        let sections = []
        const labels = [];
        let sectionDataForThisColumn = [];
        const newData = ReorganiseData(data);

        const dateInterval = filterState.filters.filter(t => t.Key === "dateinterval");
        for (const line of newData) { 
            const newLabel = dateInterval[0].values[0] === "480" ? line.MonthName.substring(0,3) : dateInterval[0].values[0] === "481" ? line.Year : line.Day;
            if (newLabel !== currentLabel) {
                if (sectionDataForThisColumn.length > 0) {
                    sections = AddNewSection(sections, sectionDataForThisColumn, labelKeyCount);
                }
                labelKeyCount++;
                labels.push({Key: labelKeyCount, Value: newLabel});
                currentLabel = newLabel;
                sectionDataForThisColumn = [];
            }
            sectionDataForThisColumn.push({Value: line.Value, Number: line.Number})
        }

        if (sectionDataForThisColumn.length > 0) {
            sections = AddNewSection(sections, sectionDataForThisColumn, labelKeyCount);
        }
        setThreeDimensions({Labels: labels, Sections: sections});
        return {Labels: labels, Sections: sections};
    }

    const dataRetrievedSuccessfully = (data) => {
        const three = GenerateThreeDimensions(data);
        CreateTwoDimensionsFromThreeDimensions(three);
        setSourceData(data);
    }

    const errorWhenRetrievingData = (data) => {
        let x = 1;
    }

    const handleRefreshButton = () => {
        GenerateData();
    }


    let filter = (null);

    const filterClickHandler = () => {
        GenerateData();
    } 

    const menuClickHandler = (button) => {
        if (button.key === "exportdata") {
            if (sourceData !== undefined) {
                downloadData();
            }
        } else {
            if (button.key === "exportgraphimage") {
                if (sourceData !== undefined) {
                    exportGraphImage();
                }
            } else {
                const action = props.uievents.filter(a => a.Name === button.UIEvent);
                var newGraph = props.graphs.filter(a => a.Name === action[0].Action);
                setCurrentGraph(newGraph[0]);
                let filters = AddListsIntoFilters(newGraph[0].Filters, props.lists);
                filters = filters.map((f) => {
                    return ( { ...f, values: [] });
                });;
                setDefaultFilters(filters);
                setFilterState({filters: filters});
                setThreeDimensions(undefined);
                setTwoDimensions(undefined);
            }
        }
    } 

    const clearFilter = () => {
        const filters = filterState.filters.map((f) => {
            const returnValue = f.Key === "graphtype" || f.Key === "dateinterval" ?  { ...f} : { ...f,  values: [] };
            return ( returnValue );
        });;
        filterState.startDate = undefined;
        filterState.endDate = undefined;
        setFilterState({...filterState, filters: filters});
    }

    function fillCanvasBackgroundWithColor(canvas, color) {
        const context = canvas.getContext('2d');
        context.save();
        context.globalCompositeOperation = 'destination-over';
        context.fillStyle = color;
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.restore();
      }

    const exportGraphImage = () => {
        const graph = graphElement.current;
        if (graph) {
            const canvasElement = graph.canvas;
            fillCanvasBackgroundWithColor(canvasElement, 'white')
            let canvas = canvasElement.toDataURL('image/jpeg');
            var hiddenElement = document.createElement('a');
            hiddenElement.href = canvas;
            hiddenElement.download = 'graphimage.jpg';
            document.body.appendChild(hiddenElement);
            hiddenElement.click();
        }
    }

    const dateChangeHandler = (key, newValue) => {
        let newState;
        if (key === "StartDate") {
            newState = {...filterState, startDate: newValue};
        } else {
            newState = {...filterState, endDate: newValue};
        }

        setFilterState(newState);
    }

    const filterDropDownHandler = (event, option, key) => {
        const state = ChangeFilterCondition(option, key, filterState);
        setFilterState(state);

        if (key = "graphtype") {
            const graphToChange = currentGraph;
            if (option.key === "477" || option.key === "478") {
                graphToChange.Type = "bar";
                graphToChange.Stack = option.key === "477";
            }
            if (option.key ==="482") {
                graphToChange.Type = "line";
            }
            if (option.key ==="485") {
                graphToChange.Type = "donut";
            }
            if (option.key ==="483") {
                graphToChange.Type = "pie";
            }
            // if (option.key ==="484") {
            //     graphToChange.Type = "polar";
            // }
            setCurrentGraph(graphToChange);
        }
    }

    const OrganiseSourceDataForExport = (data) => {
        const dataForExport = [];
        const intervalFilter = filterState.filters.filter(f => f.Key === "dateinterval")[0].values[0];
        for (const row of sourceData) {
            let newItem = {Year: row.Year, Number: row.Number, Value: row.Value};
            if (intervalFilter === "480" || intervalFilter === "479") {
                newItem.Month = row.Month;
                newItem.MonthName = row.MonthName;
            }
            if (intervalFilter === "479") {
                newItem.Day = row.Day;
            }
            dataForExport.push(newItem);
        }        
        return dataForExport;
    }

    const GenerateCsv  = () => {

        const dataToExport = OrganiseSourceDataForExport(sourceData);
        let header = "";
        let csv = [];
        let firstRecord = true;
        if (Array.isArray(dataToExport)) {
            for (const row of dataToExport) {
                let line = "";
                for(const key in row) {
                    if (firstRecord) {
                        header += header === "" ?  key : "|" + key;
                    }
                    line += line === "" ?  row[key].toString().trim() : "|" + row[key].toString().trim();
                }
                if (firstRecord) {
                    csv.push(header);
                    firstRecord = false;
                }
                csv.push(line);
            }
            firstRecord = false;
        };
        return csv;

    }

    const downloadData = () => {            
        const csvData = GenerateCsv();
        let csv = "";
        for (const row of csvData) {
            let csvRow = '\"' + row.replace(/\|/g, '","') + '\"' ;
            csv += csvRow + '\n';
        }

        var hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
        hiddenElement.target = '_blank';
        hiddenElement.download = 'export_run.csv';
        hiddenElement.click();
    }

    const buttons = MapButtons(props.config.Buttons);
    const topBarMenu = <TopBarMenu 
                            onFilterClick={filterClickHandler}
                            onFullScreenClick={props.toggleFullScreen}
                            buttons={buttons}
                            clickButton={menuClickHandler}>
                        </TopBarMenu>

    if (filterState.filters !== undefined && Array.isArray(filterState.filters)) {
        filter = <CombinedFilter
                    config={filterState}
                    view={props.config.Name}
                    filterDropDownHandler={filterDropDownHandler}
                    language={props.language}
                    refresh={handleRefreshButton}
                    onClear={clearFilter}
                    searchText={filterState.textSearch}
                    dateChangeHandler={dateChangeHandler}
                    filterSearch={false}
                    startDate={filterState.startDate}
                    endDate={filterState.endDate}
                    dateSearch={currentGraph.dateSearch}>
                </CombinedFilter>
    }

    let graphToDisplay = (null);
    if (threedimensions !== undefined && twodimensions !== undefined) {
        if (sourceData !== undefined && sourceData.length > 0) {
            const graphData = FormatDataIntoGraph(threedimensions, twodimensions, backgroundColors, currentGraph.Type);
            graphToDisplay  = (<div className="graph-graph"><GraphFactory ref={graphElement} data={graphData} text={currentGraph.Title} type={currentGraph.Type} stack={currentGraph.Stack}></GraphFactory></div>);
        } else {
            const noDataMessage = TranslateTag("@GraNo@", props.language);
            graphToDisplay = (<div class="app-crafted-fullscreencontent"><div class="graph-title">{noDataMessage}</div><div class="graph-message">{currentGraph.Message}</div></div>)
        }
    } else {
        graphToDisplay = (<div class="app-crafted-fullscreencontent"><div class="graph-title">{currentGraph.Title}</div><div class="graph-message">{currentGraph.Message}</div></div>)
    }

    return (
        <div>
            {!props.showFullScreen ? (
                <div>
                    <div className='managelist-title'>{props.config.Title}</div>
                    <div className='managelist-heading-text'>{props.config.HeaderText}</div>
                </div>
            ) : (null)}
            {topBarMenu}
            {filter}
            <div className="graph-container">
                {graphToDisplay}
            </div>
        </div>
    )
};

const mapStateToProps = state => {
    return {
        showFullScreen: state.display.showFullScreen,
        lists: state.config.lists,
        graphs: state.config.graphs,
        uievents: state.config.uievents,
        language: state.config.language
    };
}

export default connect(mapStateToProps)(Graph);